import { createSelectorHook } from 'react-redux';
import { combineReducers } from 'redux';

import page from './page';
import user from './user';

const rootReducer = combineReducers({
  user,
  page,
});

export type RootState = ReturnType<typeof rootReducer>;

export const useTypedSelector = createSelectorHook<RootState>();

export default rootReducer;
